export function publish (el, name, details) {
    const event = new CustomEvent(name, {detail: details});
    el.dispatchEvent(event);
}

export function subscribe (eventName, fn) {
    addEventListener(eventName, fn);
}
